"use strict";

exports.__esModule = true;
exports.default = exports.focusObj = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _reactGa = require("react-ga");

var _Input = _interopRequireDefault(require("../../Input"));

var _LinkButton = _interopRequireDefault(require("../../LinkButton"));

var _ButtonGroup = _interopRequireDefault(require("../../ButtonGroup"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _Select = _interopRequireDefault(require("../../Select"));

var _Option = _interopRequireDefault(require("../../Select/Option"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-bottom: ", ";\n\tdisplay: flex;\n\tflex-flow: row wrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: 0px;\n\tdisplay: flex;\n\talign-items: center;\n\tflex-grow: 1;\n\theight: 44px;\n\tjustify-content: flex-end;\n\t@media (max-width: ", ") {\n\t\tjustify-content: flex-start;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 !important;\n\tmargin-right: ", " !important;\n\tmargin-bottom: ", " !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 !important;\n\tmargin-right: ", " !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

// components
var StyledInput = (0, _styledComponents.default)(_Input.default)(_templateObject(), _spacing.default.s1);
StyledInput.displayName = 'Input';
var StyledSelect = (0, _styledComponents.default)(_Select.default)(_templateObject2(), _spacing.default.s1, _spacing.default.s1);
StyledSelect.displayName = 'Select';
var FloatButtonGroup = (0, _styledComponents.default)(_ButtonGroup.default)(_templateObject3(), _breakpoints.default.tablet);
FloatButtonGroup.displayName = 'ButtonGroup';

var Wrapper = _styledComponents.default.div(_templateObject4(), _spacing.default.s2);

Wrapper.displayName = 'Wrapper';
var ClearButton = (0, _styledComponents.default)(_LinkButton.default)(_templateObject5());
ClearButton.displayName = 'ClearButton';

var focusObj = function focusObj(obj) {
  /* istanbul ignore next */
  if (obj.current) {
    obj.current.focus();
  }
};

exports.focusObj = focusObj;

var FilterBar = function FilterBar(_ref) {
  var GA = _ref.GA,
      value = _ref.value,
      update = _ref.update,
      type = _ref.type,
      updateType = _ref.updateType,
      selectAll = _ref.selectAll,
      deselectAll = _ref.deselectAll,
      disableSelect = _ref.disableSelect,
      disableDeselect = _ref.disableDeselect,
      hideSelectAll = _ref.hideSelectAll;
  var textInput = (0, _react.createRef)();
  return _react.default.createElement(Wrapper, null, _react.default.createElement(StyledSelect, {
    name: "filter-type",
    value: type,
    onChange: function onChange(e) {
      updateType(e.target.value);
      focusObj(textInput);
      (0, _reactGa.event)({
        action: "Search by " + e.target.value,
        category: GA.category
      });
    }
  }, _react.default.createElement(_Option.default, {
    value: "name"
  }, "Search by name"), _react.default.createElement(_Option.default, {
    value: "group"
  }, "Search by group")), _react.default.createElement(StyledInput, {
    onBlur: function onBlur() {
      (0, _reactGa.event)({
        action: 'Enter Name',
        category: GA.category
      });
    },
    value: value,
    onChange: function onChange(e) {
      return update(e.target.value);
    },
    placeholder: "Enter name",
    ref: textInput
  }), _react.default.createElement(FloatButtonGroup, null, value && _react.default.createElement(ClearButton, {
    onClick: function onClick() {
      (0, _reactGa.event)({
        action: 'Clear Filter',
        category: GA.category
      });
      update('');
    }
  }, "Clear filter"), !value && !hideSelectAll && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_LinkButton.default, {
    disabled: disableSelect,
    onClick: function onClick() {
      selectAll();
      (0, _reactGa.event)({
        action: 'Select All',
        category: GA.category
      });
    }
  }, "Select all"), _react.default.createElement(_LinkButton.default, {
    disabled: disableDeselect,
    onClick: function onClick() {
      deselectAll();
      (0, _reactGa.event)({
        action: 'Deselect All',
        category: GA.category
      });
    }
  }, "Deselect all"))));
};

FilterBar.displayName = 'FilterBar';
FilterBar.propTypes = {
  GA: (0, _propTypes.shape)({
    category: _propTypes.string
  }).isRequired,
  value: _propTypes.string,
  update: _propTypes.func.isRequired,
  type: _propTypes.string.isRequired,
  updateType: _propTypes.func.isRequired,
  selectAll: _propTypes.func.isRequired,
  deselectAll: _propTypes.func.isRequired,
  disableSelect: _propTypes.bool,
  disableDeselect: _propTypes.bool,
  hideSelectAll: _propTypes.bool
};
FilterBar.defaultProps = {
  value: '',
  disableSelect: false,
  disableDeselect: false,
  hideSelectAll: false
};
var _default = FilterBar;
exports.default = _default;